import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { DokumentiService } from '../pages/dokumenti/dokumenti.service';
import { AuthService } from '../shared/services';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfZaOtpremnicePekarTomoService {

  idkorisnik: any = localStorage.getItem('idsecuser');
  idfirma: any = localStorage.getItem('firma');
  detaljiOtpremnice: any;
  prometstavke: any;
  kartoni: any;
  
  constructor(private service: DokumentiService, private authService: AuthService) {}

  //IZRDA PDF-a OTPREMNICE PEKAR TOMO HR
  pdfOtpremnicaHR(data) {
    //console.log('DATA: ', data);
    return new Promise((resolve) => {

      let podaciZaSlanje = {
        pz_id: data.data.pz_id,
        idkorisnik: this.idkorisnik,
        idfirma: this.idfirma 
      }

      this.service.otpremnica_detalji(podaciZaSlanje).subscribe((res) => {
        //console.log('res: ', res);
        if (res.success) {
          this.detaljiOtpremnice = res.data[0];

          this.service.dohvati_otpremnicu_pekartomo_iz_pekara(podaciZaSlanje).subscribe((res) => {
            //console.log('res: ', res);
            if (res.success == true) {
              this.prometstavke = res.prometstavke;
              this.kartoni = res.kartoni;
              
              this.kreirajPDF_HR();
              resolve(1);
            } else {
              notify(
                'Došlo je do pogreške pri dohvaćanju podataka. Pokušajte ponovo.',
                'warning',
                3000
              );
              resolve(0);
            }
          });
        } else {
          notify(
            'Došlo je do pogreške pri dohvaćanju podataka. Pokušajte ponovo.',
            'warning',
            3000
          );
        }
      });
    });
  }

  kreirajPDF_HR(){
    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    let ct = [];

    ct.push({
      columns: [
        {
          table: {
            widths: [200],
            heights: [95],
            body: [
              [
                {
                  table: {
                    body: [
                      [
                        {
                          text: 'Isporuka: ' + this.detaljiOtpremnice.pa_naziv,
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: 'OIB: ' + this.detaljiOtpremnice.pa_oib,
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: ` 
                            Poslovnica kupca: 
                            ${this.detaljiOtpremnice.pp_naziv}
                            ${this.detaljiOtpremnice.pp_adresa}
                            ${this.detaljiOtpremnice.pp_posta || ''}` + ' ' + `${this.detaljiOtpremnice.pp_mjesto || ''}`,
                          style: 'subtitle',
                          bold: true,
                        }
                      ]
                    ],
                  },
                  layout: 'noBorders',
                },
              ],
            ],
          },
        },

        {
          table: {
            widths: [250],
            heights: [95],
            body: [
              [
                {
                  table: {
                    body: [
                      [
                        {
                          text: 'PEKAR TOMO d.o.o.',
                          style: 'title',
                        },
                      ],
                      [
                        {
                          text: 'H.D.GENSCHERA 22b',
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: 'Vinkovci',
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: 'Društvo upisano kod Trgovačkog suda u Osijeku MBS: 030142165, OIB: 26641815251. Temeljni kapital 20.000,00 kn; Predsjednik uprave: Bosiljko Stanić, direktor. Ž.r. Privredna banka Zagreb 2340009-1111180856  IBAN: HR6823400091111180856 SWIFT: PBZGHR2X  Ž.r. Otp bank 2407000-1100520571 IBAN: HR5224070001100520571 SWIFT: OTPVHR2X',
                          style: 'details',
                        },
                      ],
                    ],
                  },
                  layout: 'noBorders',
                },
              ],
            ],
          },
        },
      ],
    });

    ct.push({
      text: '\n' + '\n',
    });

    ct.push({
      columns: [
        {
          
        },

        {
          text:
            `Datum otpremnice: ${moment(this.detaljiOtpremnice.pz_datum).format('DD.MM.YYYY')}.
            Datum kreiranja: ${moment(this.detaljiOtpremnice.pz_danisat).format('DD.MM.YYYY. HH:mm:ss')}.
            Broj narudžbe: ${this.detaljiOtpremnice.dokument_do_id_narudzba || ''}`,
          style: 'subtitle',
        },
      ],
    });

    ct.push({
      text: '\n' + '\n',
    });

    //SREDINA OTPREMNICA I BROJ OTPREMNICE
    ct.push({
      text:
        'Otpremnica: ' +
        this.detaljiOtpremnice.po_sifra +
        '-' +
        this.detaljiOtpremnice.pz_broj +
        '/' +
        moment(this.detaljiOtpremnice.pz_datum).format('YYYY'),
      style: 'mainTitle',
      alignment: 'center',
      margin: [0, 0, 0, 0],
    });

    //GLAVNA TABLICA I PODACI
    let brojac = 1;
    let ukupnoKolicina = 0;
    let ukupnoTezina = 0;
    let ukupnoBrojKartona = 0;
    let ukupnoBrojPaleta = 0;
    let ukupnaTezinaAmbalaze = 0;

    let arr = this.prometstavke; //res.prometstavke;
    let kartoni = this.kartoni; //res.kartoni;
    let result = arr.reduce(function (r, a) {
      r[a.ar_lot] = r[a.ar_lot] || [];
      r[a.ar_lot].push(a);
      return r;
    }, Object.create(null));
    //console.log(result);

    kartoni.forEach(karton => {
      //console.log(kartoni)
      ukupnaTezinaAmbalaze += karton.ukupna_tezina_ambalaze
    });

    ct.push(hLine);
    ct.push({
      table: {
        //Rbr. Šifra EAN kod Naziv artikla Jed. mjere Količina Neto težina Broj kartona Broj paleta Još izdano
        widths: [15, 30, 55, 140, 25, 35, 35, 30, 22, 23],
        body: [
          [
            'Rb',
            'Šifra' + '\n' + 'LOT',
            'EAN kod' + '\n' + 'Rok trajanjaa',
            'Naziv artikla',
            'Jed. mjere',
            'Količina',
            'Neto težina (kg)',
            'Broj kartona',
            'Broj paleta',
            'Još izdano',
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });

    ct.push(hLine);
    for (let lot in result) {
      let stavkaSifra = '';
      let stavkaEanKod = '';
      let stavkaNaziv = '';
      let stavkaJedMjere = '';
      let stavkaKolicina = 0;
      let stavkaNetoTezina = 0;
      let stavkaBrojKartona = 0;
      let stavkaBrojPaleta = 0;
      let stavkaJosIzdano = '';

      //console.log('RESULT ', result);
      //console.log('LOT: ', lot);


      for (let stavka of result[lot]) {
        //console.log('STAVKA: ', stavka);
        //console.log('result[lot]: ', result[lot]);

        stavkaSifra = stavka.ar_sifra + '\n' + stavka.ar_lot;
        //bilo, 26.09.2025. izmjenjeno na zahtjev Martine
        //stavkaEanKod = stavka.bk_kod + '\n' + moment(stavka.pz_datum).add(stavka.ar_roktrajanja, 'd').format('DD.MM.YYYY');
        stavkaEanKod = (stavka.bk_kod + '\n' + ((stavka.ps_vazido != null ? moment(stavka.ps_vazido).format('DD.MM.YYYY') : (stavka.vazi_do_rnalog != null ? moment(stavka.vazi_do_rnalog).format('DD.MM.YYYY') : '/'))));
        stavkaNaziv = stavka.ar_naziv;
        stavkaJedMjere = stavka.jedinicamjere_JM_SIFRA;
        stavkaKolicina = stavka.ps_izlaz;
        stavkaNetoTezina = (stavka.ar_tezina) || 0;
        stavkaBrojKartona = (stavka.ps_izlaz != 0 && stavka.bk_ukarton != 0) ? (stavka.ps_izlaz / stavka.bk_ukarton) : 0;
        stavkaBrojPaleta = (stavka.ps_izlaz != 0 && stavka.bk_ukarton != 0 && stavka.bk_kartonpaleta != 0) ? stavka.ps_izlaz / (stavka.bk_ukarton * stavka.bk_kartonpaleta) : 0;
        // stavkaJosIzdano = '______'; //HARDCODED

        ukupnoKolicina += stavka.ps_izlaz;
        ukupnoTezina += stavka.ar_tezina;
        ukupnoBrojKartona += stavkaBrojKartona;
        ukupnoBrojPaleta += stavkaBrojPaleta;
      }

      ct.push({
        table: {
          //Rbr. Šifra EAN kod Naziv artikla Jed. mjere Količina Neto težina Broj kartona Broj paleta Još izdano
          widths: [15, 30, 55, 140, 25, 35, 35, 30, 22, 23],
          body: [
            [
              brojac++,
              stavkaSifra,
              stavkaEanKod,
              stavkaNaziv,
              stavkaJedMjere,
              { text: this.formatiraj(stavkaKolicina, 2), alignment: 'right'},
              { text: this.formatiraj(stavkaNetoTezina, 2), alignment: 'right'},
              { text: this.formatiraj(stavkaBrojKartona, 2), alignment: 'right'},
              { text: this.formatiraj(stavkaBrojPaleta, 2), alignment: 'right'},
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
    }

    //UKUPNO
    ct.push(hLine);
    ct.push({
      table: {
        widths: [321, 50, 44, 38, 30],
        body: [
          [
            {
              text: 'UKUPNO',
              style: 'tableFooter',
              margin: [5, 0, 0, 0],
            },
            { text: this.formatiraj(ukupnoKolicina, 2), alignment: 'right', style: 'tableFooter' },
            { text: this.formatiraj(ukupnoTezina, 2), alignment: 'right', style: 'tableFooter' },
            { text: this.formatiraj(ukupnoBrojKartona, 2), alignment: 'right', style: 'tableFooter' },
            { text: this.formatiraj(ukupnoBrojPaleta, 2), alignment: 'right', style: 'tableFooter' },
          ],
        ],
      },
      layout: 'noBorders',
    });

    //POTPISI
    let signatureLine = {
      table: {
        widths: ['100%'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    ct.push({
      columns: [
        [
          {
            text: 'Robu otpremio:',
            margin: [0, 60, 0, 30],
            aligment: 'center',
          },
          signatureLine,
        ],
        [],
        [],
        [
          {
            text: 'Robu primio:',
            margin: [0, 60, 0, 30],
            aligment: 'center',
          },
          signatureLine,
        ],
      ],
    });

    var dd = {
      info: {
        title: 'Otpremnica: ' + this.detaljiOtpremnice.pz_id,
      },
      content: ct,
      pageMargins: 20,
      defaultStyle: {
        fontSize: 7.5,
      },
      styles: {
        title: {
          fontSize: 12,
          bold: true,
        },
        subtitle: {
          fontSize: 10,
        },
        details: {
          fontSize: 6,
        },
        tableTitle: {
          fontSize: 8,
          bold: true,
        },
        mainTitle: {
          fontSize: 17,
          bold: true,
        },
        tableFooter: {
          bold: true,
        },
      },
    };

    let drzava_naziv = '';
    if (this.detaljiOtpremnice.dr_naziv) {
      drzava_naziv = ' - ' + `${this.detaljiOtpremnice.dr_naziv || ''}`
    }

    //PODACI NAKON POTPISA
    ct.push({
      columns: [
        {
          table: {
            widths: [500],
            body: [
              [
                {
                  text: 'Prijevozni agent: ' + (this.detaljiOtpremnice.prijevoznik || ''),
                  bold: true,
                },
              ],

              [''],

              [
                {
                  text: `${this.detaljiOtpremnice.crossdock_naziv || ''}`, bold: true,
                },
              ],

              [
                {
                  text: `${this.detaljiOtpremnice.crossdock_adresa || ''}`, bold: true,
                },
              ],

              [
                {
                  text: `${this.detaljiOtpremnice.crossdock_posta || ''}` + ' ' + `${this.detaljiOtpremnice.crossdock_mjesto || ''}`, bold: true,
                },
              ],

              [
                {
                  text: `${this.detaljiOtpremnice.crossdock_dr_sifra || ''}` +  drzava_naziv, bold: true,
                },
              ],

              //PRAZAN RED
              [''],
              [''],
              [''],
              [''],
              [''],
              [''],
              [''],
              [''],

              [
                {
                  text: 'Broj kartona: ' + ukupnoBrojKartona.toFixed(2),
                  bold: true,
                },
              ],
              [
                {
                  text: 'Bruto težina: ' + (+ukupnoTezina + (+ukupnoBrojPaleta * 25) + +ukupnaTezinaAmbalaze).toFixed(2) + ' kg',
                  bold: true,
                },
              ],

              //PRAZAN RED
              [''],
              [''],
              [''],
              [''],

              [
                {
                  text: 'Ukupno paleta: ' + ukupnoBrojPaleta.toFixed(2),
                  bold: true,
                },
              ],

              //PRAZAN RED
              [''],
              [''],

              [
                {
                  text: 'Vrsta transporta: Kamion',
                },
              ],
              [
                {
                  text: 'Paritet:',
                },
              ],
            ],
          },
          layout: 'noBorders',
        },
      ],
    });

    pdfMake.createPdf(dd).open();
  }
  

  //IZRDA PDF-a OTPREMNICE PEKAR TOMO ENG
  pdfOtpremnicaENG(data) {
    //console.log('DATA: ', data);
    return new Promise((resolve) => {

      let podaciZaSlanje = {
        pz_id: data.data.pz_id,
        idkorisnik: this.idkorisnik,
        idfirma: this.idfirma
      }

      this.service.otpremnica_detalji(podaciZaSlanje).subscribe((res) => {
        //console.log('res: ', res);
        if (res.success == true) {
          this.detaljiOtpremnice = res.data[0];

          this.service.dohvati_otpremnicu_pekartomo_iz_pekara(podaciZaSlanje).subscribe((res) => {
            //console.log('res: ', res);
            if (res.success == true) {
              this.prometstavke = res.prometstavke;
              this.kartoni = res.kartoni;

              this.kreirajPDF_ENG();
              resolve(1);
            } else {
              notify(
                'Došlo je do pogreške pri dohvaćanju podataka. Pokušajte ponovo.',
                'warning',
                3000
              );
              resolve(0);
            }
          });

        } else {
          notify(
            'Došlo je do pogreške pri dohvaćanju podataka. Pokušajte ponovo.',
            'warning',
            3000
          );
        }
      });
    });
  }

  kreirajPDF_ENG(){

    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    let ct = [];

    ct.push({
      columns: [
        {
          table: {
            widths: [200],
            heights: [95],
            body: [
              [
                {
                  table: {
                    body: [
                      [
                        {
                          text: this.detaljiOtpremnice.pa_naziv,
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: 'ID: ' + this.detaljiOtpremnice.pa_oib,
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: ` 
                            Delivery to: 
                            ${this.detaljiOtpremnice.pp_naziv}
                            ${this.detaljiOtpremnice.pp_adresa}
                            ${this.detaljiOtpremnice.pp_posta || ''}` + ' ' + `${this.detaljiOtpremnice.pp_mjesto || ''}`,
                          style: 'subtitle',
                          bold: true,
                        }
                      ]
                    ],
                  },
                  layout: 'noBorders',
                },
              ],
            ],
          },
        },

        {
          table: {
            widths: [250],
            heights: [95],
            body: [
              [
                {
                  table: {
                    body: [
                      [
                        {
                          text: 'PEKAR TOMO d.o.o.',
                          style: 'title',
                        },
                      ],
                      [
                        {
                          text: 'H.D.GENSCHERA 22b',
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: 'Vinkovci',
                          style: 'subtitle',
                        },
                      ],
                      [
                        {
                          text: 'Društvo upisano kod Trgovačkog suda u Osijeku MBS: 030142165, OIB: 26641815251. Temeljni kapital 20.000,00 kn; Predsjednik uprave: Bosiljko Stanić, direktor. Ž.r. Privredna banka Zagreb 2340009-1111180856  IBAN: HR6823400091111180856 SWIFT: PBZGHR2X  Ž.r. Otp bank 2407000-1100520571 IBAN: HR5224070001100520571 SWIFT: OTPVHR2X',
                          style: 'details',
                        },
                      ],
                    ],
                  },
                  layout: 'noBorders',
                },
              ],
            ],
          },
        },
      ],
    });

    ct.push({
      text: '\n' + '\n',
    });

    ct.push({
      columns: [
        {
          
        },

        {
          text:
            `Date: ${moment(this.detaljiOtpremnice.pz_datum).format('DD.MM.YYYY')}.
            Date of the Delivery Note: ${moment(this.detaljiOtpremnice.pz_danisat).format('DD.MM.YYYY. HH:mm:ss')}.
            Order number: ${this.detaljiOtpremnice.dokument_do_id_narudzba || ''}`,
          style: 'subtitle',
        },
      ],
    });

    ct.push({
      text: '\n' + '\n',
    });

    //SREDINA OTPREMNICA I BROJ OTPREMNICE
    ct.push({
      text:
        'Delivery note: ' +
        this.detaljiOtpremnice.po_sifra +
        '-' +
        this.detaljiOtpremnice.pz_broj +
        '/' +
        moment(this.detaljiOtpremnice.pz_datum).format('YYYY'),
      style: 'mainTitle',
      alignment: 'center',
      margin: [0, 0, 0, 0],
    });

    //GLAVNA TABLICA I PODACI
    let brojac = 1;
    let ukupnoKolicina = 0;
    let ukupnoTezina = 0;
    let ukupnoBrojKartona = 0;
    let ukupnoBrojPaleta = 0;
    let ukupnaTezinaAmbalaze = 0;

    let arr = this.prometstavke; //res.prometstavke;
    let kartoni = this.kartoni; //res.kartoni;
    let result = arr.reduce(function (r, a) {
      r[a.ar_lot] = r[a.ar_lot] || [];
      r[a.ar_lot].push(a);
      return r;
    }, Object.create(null));
    //console.log(result);

    kartoni.forEach(karton => {
      //console.log(kartoni)
      ukupnaTezinaAmbalaze += karton.ukupna_tezina_ambalaze
    });

    ct.push(hLine);
    ct.push({
      table: {
        //Rbr. Šifra EAN kod Naziv artikla Jed. mjere Količina Neto težina Broj kartona Broj paleta Još izdano
        widths: [15, 30, 55, 150, 25, 35, 35, 30, 33],
        body: [
          [
            'NO.',
            'Code' + '\n' + 'LOT',
            'EAN code' + '\n' + 'Expiration date',
            'Product name',
            'Unit',
            'Quantity',
            'Net Weight (kg)',
            'Number of cartons',
            'Number of pallets',
          ],
        ],
      },
      layout: 'lightHorizontalLines',
    });

    ct.push(hLine);
    for (let lot in result) {
      let stavkaSifra = '';
      let stavkaEanKod = '';
      let stavkaNaziv = '';
      let stavkaJedMjere = '';
      let stavkaKolicina = 0;
      let stavkaNetoTezina = 0;
      let stavkaBrojKartona = 0;
      let stavkaBrojPaleta = 0;

      //console.log('RESULT ', result);
      //console.log('LOT: ', lot);


      for (let stavka of result[lot]) {
        //console.log('STAVKA: ', stavka);
        //console.log('result[lot]: ', result[lot]);

        stavkaSifra = stavka.ar_sifra + '\n' + stavka.ar_lot;
        //bilo, 26.09.2025. izmjenjeno na zahtjev Martine
        //stavkaEanKod = stavka.bk_kod + '\n' + moment(stavka.pz_datum).add(stavka.ar_roktrajanja, 'd').format('DD.MM.YYYY');
        stavkaEanKod = (stavka.bk_kod + '\n' + ((stavka.ps_vazido != null ? moment(stavka.ps_vazido).format('DD.MM.YYYY') : (stavka.vazi_do_rnalog != null ? moment(stavka.vazi_do_rnalog).format('DD.MM.YYYY') : '/'))));
        stavkaNaziv = stavka.ar_naziv;
        stavkaJedMjere = stavka.jedinicamjere_JM_SIFRA;
        stavkaKolicina = stavka.ps_izlaz;
        stavkaNetoTezina = (stavka.ar_tezina) || 0;
        stavkaBrojKartona = (stavka.ps_izlaz != 0 && stavka.bk_ukarton != 0) ? (stavka.ps_izlaz / stavka.bk_ukarton) : 0;
        stavkaBrojPaleta = (stavka.ps_izlaz != 0 && stavka.bk_ukarton != 0 && stavka.bk_kartonpaleta != 0) ? stavka.ps_izlaz / (stavka.bk_ukarton * stavka.bk_kartonpaleta) : 0;
        // stavkaJosIzdano = '______'; //HARDCODED

        ukupnoKolicina += stavka.ps_izlaz;
        ukupnoTezina += stavka.ar_tezina;
        ukupnoBrojKartona += stavkaBrojKartona;
        ukupnoBrojPaleta += stavkaBrojPaleta;
      }

      ct.push({
        table: {
          //Rbr. Šifra EAN kod Naziv artikla Jed. mjere Količina Neto težina Broj kartona Broj paleta Još izdano
          widths: [15, 30, 55, 150, 25, 35, 35, 30, 33],
          body: [
            [
              brojac++,
              stavkaSifra,
              stavkaEanKod,
              stavkaNaziv,
              stavkaJedMjere,
              { text: this.formatiraj(stavkaKolicina, 2), alignment: 'right'},
              { text: this.formatiraj(stavkaNetoTezina, 2), alignment: 'right'},
              { text: this.formatiraj(stavkaBrojKartona, 2), alignment: 'right'},
              { text: this.formatiraj(stavkaBrojPaleta, 2), alignment: 'right'},
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
    }

    //UKUPNO
    ct.push(hLine);
    ct.push({
      table: {
        widths: [331, 50, 44, 38, 40],
        body: [
          [
            {
              text: 'TOTAL',
              style: 'tableFooter',
              margin: [5, 0, 0, 0],
            },
            { text: this.formatiraj(ukupnoKolicina, 2), alignment: 'right', style: 'tableFooter' },
            { text: this.formatiraj(ukupnoTezina, 2), alignment: 'right', style: 'tableFooter' },
            { text: this.formatiraj(ukupnoBrojKartona, 2), alignment: 'right', style: 'tableFooter' },
            { text: this.formatiraj(ukupnoBrojPaleta, 2), alignment: 'right', style: 'tableFooter' },
          ],
        ],
      },
      layout: 'noBorders',
    });

    //POTPISI
    let signatureLine = {
      table: {
        widths: ['100%'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    ct.push({
      columns: [
        [
          {
            text: 'Goods prepared by:',
            margin: [0, 60, 0, 30],
            aligment: 'center',
          },
          signatureLine,
        ],
        [],
        [],
        [
          {
            text: 'Goods received by:',
            margin: [0, 60, 0, 30],
            aligment: 'center',
          },
          signatureLine,
        ],
      ],
    });

    var dd = {
      info: {
        title: 'Delivery note: ' + this.detaljiOtpremnice.pz_id,
      },
      content: ct,
      pageMargins: 20,
      defaultStyle: {
        fontSize: 7.5,
      },
      styles: {
        title: {
          fontSize: 12,
          bold: true,
        },
        subtitle: {
          fontSize: 10,
        },
        details: {
          fontSize: 6,
        },
        tableTitle: {
          fontSize: 8,
          bold: true,
        },
        mainTitle: {
          fontSize: 17,
          bold: true,
        },
        tableFooter: {
          bold: true,
        },
      },
    };

    let drzava_naziv = '';
    if (this.detaljiOtpremnice.dr_naziv) {
      drzava_naziv = ' - ' + `${this.detaljiOtpremnice.dr_naziv || ''}`
    }

    //PODACI NAKON POTPISA
    ct.push({
      columns: [
        {
          table: {
            widths: [500],
            body: [
              [
                {
                  text: 'Transport agent: ' + this.detaljiOtpremnice.prijevoznik,
                  bold: true,
                },
              ],

              [''],

              [
                {
                  text: `${this.detaljiOtpremnice.crossdock_naziv || ''}`, bold: true,
                },
              ],

              [
                {
                  text: `${this.detaljiOtpremnice.crossdock_adresa || ''}`, bold: true,
                },
              ],

              [
                {
                  text: `${this.detaljiOtpremnice.crossdock_posta || ''}` + ' ' + `${this.detaljiOtpremnice.crossdock_mjesto || ''}`, bold: true,
                },
              ],

              [
                {
                  text: `${this.detaljiOtpremnice.crossdock_dr_sifra || ''}` +  drzava_naziv, bold: true,
                },
              ],

              //PRAZAN RED
              [''],
              [''],
              [''],
              [''],
              [''],
              [''],
              [''],
              [''],

              [
                {
                  text: 'Total number of cartons: ' + ukupnoBrojKartona.toFixed(2),
                  bold: true,
                },
              ],
              [
                {
                  text: 'Gross weight: ' + (+ukupnoTezina + (+ukupnoBrojPaleta * 25) + +ukupnaTezinaAmbalaze).toFixed(2) + ' kg',
                  bold: true,
                },
              ],

              //PRAZAN RED
              [''],
              [''],
              [''],
              [''],

              [
                {
                  text: 'Total number of pallets: ' + ukupnoBrojPaleta.toFixed(2),
                  bold: true,
                },
              ],

              //PRAZAN RED
              [''],
              [''],

              [
                {
                  text: 'Type of transport: Truck',
                },
              ],
            ],
          },
          layout: 'noBorders',
        },
      ],
    });

    pdfMake.createPdf(dd).open();
  }

  formatiraj(broj: any, dec_mj: any){
    return this.authService.formatiraj(broj, dec_mj);
  }
}
